export const EditAccountDetailHeader = (): JSX.Element => {
    return (
        <div>
            <div className="has-text-weight-bold">Edit account details</div>
        </div>
    );
};
